import React, { useState } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import classNames from "classnames";
import { useDebouncedEffect } from "shared/lib/debounce";

const FILTER_TOGGLER_CLASS = "fantastic-qs__filter-toggler";

const QuerySearch = ({ query, onChange, tags, selectedTags }) => {
  const [value, setValue] = useState(query);
  const [showFilters, setShowFilters] = useState(false);
  const [selected, setSelected] = useState(selectedTags);

  useDebouncedEffect(
    () => {
      onChange(value, selected);
    },
    1000,
    [value, selected]
  );

  const handleChangeValue = event => {
    setValue(event.target.value);
  };

  const filterClass = classNames("fantastic-qs__filter", {
    "fantastic-qs__filter--active": showFilters
  });

  const isActiveTag = tag => selected.includes(tag);
  const isFavoriteTag = tag => [i18n.t('my_blocks')].includes(tag);

  const toggleTag = tag => {
    if (selected.includes(tag)) {
      setSelected(selected.filter(t => t !== tag));
    } else {
      setSelected([...selected, tag]);
    }
  };

  const renderTag = (tag, index) => {
    const klass = classNames("fantastic-qs__tag", {
      "fantastic-qs__tag--active": isActiveTag(tag),
      "fantastic-qs__tag--favorite": isFavoriteTag(tag)
    });
    return (
      <div key={index} className={klass} onClick={() => toggleTag(tag)}>
        { isFavoriteTag(tag) && <i className="fa fa-star-o"></i>}
        {tag}
      </div>
    );
  };

  const renderFilterButton = () => {
    if (selected.length === 0) {
      const klass = classNames(
        "fa fa-filter",
        "fantastic-qs__filter-icon",
        FILTER_TOGGLER_CLASS
      );
      return (
        <i
          className={klass}
          onClick={() => setShowFilters(!showFilters)}
        />
      );
    }
    const klass = classNames("fantastic-qs__filter-button", FILTER_TOGGLER_CLASS);
    return (
      <div
        className={klass}
        onClick={() => setShowFilters(!showFilters)}
      >
        {selected.length}
      </div>
    );
  };

  const closeFilter = (e) => {
    if (e.target.classList.contains(FILTER_TOGGLER_CLASS)) return;
    setShowFilters(false);
  };

  return (
    <div className="fantastic-qs">
      <div className="fantastic-qs__control">
        <input
          placeholder={i18n.t('element_search')}
          value={value}
          onChange={handleChangeValue}
          className="form-control fantastic-form-control"
        />
        <i className="fi fi-search fantastic-qs__lupa" />
        {renderFilterButton()}
        <OutsideClickHandler onOutsideClick={closeFilter}>
          <div className={filterClass}>
            <div className="fantastic-qs__filter--content">
              {[i18n.t('my_blocks'), ...tags].map(renderTag)}
            </div>
          </div>
        </OutsideClickHandler>
      </div>
    </div>
  );
};

export default QuerySearch;
